import { userService } from '@public/service/user/user';
import { AES } from '@common/utils/common';
import { TUser } from './types';

export default {
  fetchUserInfo: async function () {
    const result = await userService().getUserInfo();
    if (!result) return;

    this.name = AES.aesDecip(result.aesName);
    this.time = result.aesTime;
    this.idCardNum = result.ident;
    this.userId = result.userId;
    this.isStudent = result.studentFlag === '1';
    this.isIdCardExpired = result.isIdcardExpired === '1';
    this.appleBound = !!result.appleBindFlag;
    this.isRealName = !!result.hasChecked;
    this.hasTransPwd = !!result.hasTransPwd;
    this.loginType = result.loginType;
    this.mobile = result.mobile;
    this.refusePeriod = result.refusePeriod === '1';
    this.uniqueId = result.uniqueId;
    // 无返回值，所有信息均在实体表格内拿取
  },
  // 返回表格内所有内容
  getAllInfo: function (): TUser {
    const state = {};
    // 只返回参数
    for (const key in this) {
      if (typeof this[key] !== 'function') {
        state[key] = this[key];
      }
    }
    return <TUser>state;
  },
  // 更新某一个参数
  updateOneItem: function (key, value) {
    if (!Object.prototype.hasOwnProperty.call(this, key)) throw new Error(`${key}参数不存在`);

    this[key] = value;
  },

  //todo 增加联系人
  addContacts: async function (tempApplyNo: string) {
    const params = {
      empPost: this.occupation,
      contact: [
        {
          aesName: AES.aesEncry(this.contacts[0].name),
          aesMobile: AES.aesEncry(this.contacts[0].phoneNum),
        },
        {
          aesName: AES.aesEncry(this.contacts[1].name),
          aesMobile: AES.aesEncry(this.contacts[1].phoneNum),
        },
      ],
      monthIncomeRange: this.monthIncomeRange,
      tempApplyNo: tempApplyNo,
    };
    const result = await userService().addContacts(params);

    return result;
  },
};
